/***
*
*   ICON
*   Render an icon from feather icons
*
*   PROPS
*   color: dark/light/grey/green/orange/blue or hex code
*   pack: icon pack to use, default is feathericons
*   image: image to use (see: https://feathericons.com)
*   className: inject a parent class object
*   onClick: function to run on click
*
**********/

import FeatherIcon from 'feather-icons-react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { fab } from '@fortawesome/free-brands-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';
import { CUSTOM_ICONS, CustomIcon } from './custom';

export function Icon(props){

  let color;
  
  const packs = {

    fontawesome: FontAwesomeIcon,
    feather: FeatherIcon
  
  }

  switch (props.color){

    case 'light':
    color = '#FFFFFF';
    break;

    case 'dark':
    color = 'hsl(var(--text-secondary))';
    break;

    case 'grey':
    color = 'hsl(var(--text-muted))';
    break;

    case 'green':
    color = '#10B981';
    break;

    case 'blue':
    color = '#4F46E5';
    break;
    
    case 'orange':
    color = '#F59E0B'
    break;

    case 'red':
    color = '#EF4444';
    break;

    case 'purple':
    color = '#4F46E5';
    break;

    default:
    color = props.color;
    break;

  }

  // Glyphs with no Feather equivalent are drawn locally — see ./custom.js
  if (!props.pack && CUSTOM_ICONS[props.image])
    return (
      <CustomIcon
        image={ props.image }
        color={ color }
        size={ props.size }
        className={ props.className }
        onClick={ props.onClick }
      />
    );

  if (props.pack === 'fontawesome')
    library.add(fab);

  const Icon = packs[props.pack || 'feather'];

  return(
    <Icon
      color={ color }
      icon={ props.image }
      size={ props.size || 16 }
      className={ props.className }
      onClick={ props.onClick }
    />
  )
}

